import superagent from '@ott/superagent';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RequestError } from '../../types';
import prepareQuery from '../../helpers/prepareQuery';
import { RequestResponse } from './types';

export const getRefillLink = createAsyncThunk<
  RequestResponse,
  undefined,
  { rejectValue: RequestError }
>('virtualCard/refillLink/fetch', async (_, { rejectWithValue }) => {
  try {
    const url = '/_virtual_cards/abb/p2p';
    const params = prepareQuery({
      backRef: 'https://static.onetwotrip.com/redirect/redirect-result.html',
    });

    const {
      body: { error, result },
    } = await superagent.get(url).query(params);

    if (error) {
      throw error;
    }

    return result as RequestResponse;
  } catch (error: any) {
    return rejectWithValue(error.response.body as RequestError);
  }
});
